// import "antd/dist/antd.css";
import React from "react";
import './styles/globals.css'
import {BrowserRouter} from "react-router-dom";
import RounterUrl from "./RouterUrl";
import Footer from "./component/Components/Footer";
import Popup from "./component/Components/Popup";
import {useAppContext} from "./context/Context";
import IntroductionPage from './component/IntroductionPage'

import Navbar from "./component/Components/Navbar";
import MainLayout from "./component/MainLayout";

function App() {
  // const {popup, setPopup} = useAppContext();
  return (
      // <BrowserRouter>
      //   {/* <Navbar /> */}
      //   {/* <Popup /> */}
      //   <RounterUrl setPopup={setPopup} popup={popup} />
      //   {/* <Footer /> */}
      // </BrowserRouter>
      <main className="relative">
          <MainLayout/>
      </main>
  );
}

export default App;
